import React from 'react';
import AuditHistoryTab from '../../audit/AuditHistoryTab';

interface Props {
  deviceId: string;
}

/** Audit-log entries filtered to this device. */
export const DevicesDetailsHistory: React.FC<Props> = ({ deviceId }) => (
  <div className="modal-content tab-content">
    <AuditHistoryTab resourceType="device" resourceId={deviceId} />
  </div>
);
